<template>
  <div class="price-filter-override">
    <FreeSlider
      ref="pricesSliderRef"
      :configs="priceSlider"
      @change:model-value="handlePriceChange"
    >
      <template #title>
        <h2 class="text-text-neutral-primary text-lg font-semibold">
          {{ $t('search.filters.ticketPrice') }}
        </h2>
      </template>
      <template #labels="{ labels }">
        <div
          class="text-text-neutral-tertiary flex w-full justify-end text-xs font-medium"
        >
          <p v-price="labels[0]"></p>
        </div>
      </template>
    </FreeSlider>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue';
  import { FreeSlider } from 'freedom-shared';
  import { debounce } from 'lodash-es';

  const props = defineProps<{
    state: number[];
    limits: number[];
  }>();

  const emit = defineEmits<{
    (e: 'onPriceUpdate', prices: number[]): void;
  }>();

  const pricesSliderRef = ref<InstanceType<typeof FreeSlider>>();

  const priceSlider = computed(() => ({
    start: props.state[1] ?? props.limits[1],
    range: {
      min: 0,
      max: props.limits[1],
    },
    step: 100,
    padding: [props.limits[0], 0],
    connect: [true, false],
  }));

  function updatePrice(value: number) {
    if (props.state[1] !== value) {
      emit('onPriceUpdate', [props.state[0], value]);
    }
  }

  const debounceChange = debounce(updatePrice, 300);

  function handlePriceChange(value: number) {
    debounceChange(Math.floor(value));
  }

  // we have to watch price filter state for update slider inner state
  watch(
    () => props.state,
    newState => {
      pricesSliderRef?.value?.sliderAPI?.set(newState[1]);
    },
    { deep: true },
  );
</script>

<style scoped lang="postcss">
  .price-filter-override {
    @apply bg-background-neutral-secondary space-y-4 rounded-2xl p-4;
    --slider-handler-lower-right: 0px;
    --slider-target-padding-left: 0px;
    --slider-target-padding-right: 0px;
  }
</style>
